import { render, staticRenderFns } from "./ModalEditarRequestBodyRequisicao.vue?vue&type=template&id=57a5a6d9&scoped=true"
import script from "./ModalEditarRequestBodyRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarRequestBodyRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarRequestBodyRequisicao.vue?vue&type=style&index=0&id=57a5a6d9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5a6d9",
  null
  
)

export default component.exports